import { Navigation03Icon, PencilEdit01Icon } from '@hugeicons/core-free-icons';
import { Controller, useForm } from 'react-hook-form';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, InputGroup, MultipleChoice, Select } from 'components/FormComponents';

export const NewRefereeModal = ({
  visible,
  candidateForms = [],
  refereeForms = [],
  onSelect = () => {},
  onClose = () => {},
}) => {
  const { control, register, handleSubmit, watch } = useForm();

  const candidateFormIdValue = watch('candidate_form_id');
  const refereeFormIdValue = watch('referee_form_id');

  return (
    <AnimatedModal
      title="Add Referee"
      description="Please choose the candidate & referee forms you'd like to send, and let us know how you'd prefer to provide the details for this additional referee."
      visible={visible}
      onClose={onClose}
      small
      className="u-min-width-small">
      <form onSubmit={handleSubmit(onSelect)}>
        <div className="card">
          <div className="card">
            <InputGroup title="Candidate Form">
              <Select
                name="candidate_form_id"
                register={register}
                value={candidateFormIdValue}
                useDefault>
                {candidateForms.map(candidateForm => (
                  <Select.Item value={candidateForm.id} key={candidateForm.id}>
                    {candidateForm.name}
                  </Select.Item>
                ))}
              </Select>
            </InputGroup>

            <InputGroup title="Referee Form" className="u-margin-bottom--0">
              <Select
                name="referee_form_id"
                register={register}
                value={refereeFormIdValue}
                useDefault>
                {refereeForms.map(refereeForm => (
                  <Select.Item value={refereeForm.id} key={refereeForm.id}>
                    {refereeForm.name}
                  </Select.Item>
                ))}
              </Select>
            </InputGroup>
          </div>

          <Controller
            name="input_type"
            defaultValue="enter_details"
            control={control}
            render={({ field: { onChange, value } }) => (
              <MultipleChoice
                className="u-margin-top"
                value={value}
                options={{
                  options: [
                    {
                      name: 'Enter Referee Details Yourself',
                      description: "Manually enter the referee's details into Checkmate.",
                      value: 'enter_details',
                      icon: PencilEdit01Icon,
                    },
                    {
                      name: 'Ask Candidate to Provide Details',
                      description:
                        "We'll notify the candidate to add their referee's information directly.",
                      value: 'ask_candidate',
                      icon: Navigation03Icon,
                    },
                  ],
                }}
                onChange={onChange}
                radioButtonStyle
                prefixIcon
              />
            )}
          />
        </div>

        <div className="d-flex justify-content-between u-margin-top--large">
          <Button className="u-width-100" onClick={onClose} type="secondary">
            Cancel
          </Button>
          <Button className="u-width-100 u-margin-left--large" submit>
            Add Referee
          </Button>
        </div>
      </form>
    </AnimatedModal>
  );
};
